module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.9a88d5b.woff";